/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'ajs-legacy';
const componentName = 'event-details';
const prefix = `${moduleName}.${componentName}`;

export const descriptionLabel = `${prefix}.descriptionLabel`;
export const downloadCrsDataButtonLabel = `${prefix}.downloadCrsDataButtonLabel`;
export const previousConfigurationLabel = `${prefix}.previousConfigurationLabel`;
export const newConfigurationLabel = `${prefix}.newConfigurationLabel`;

export const ENGLISH = {
    [descriptionLabel]: 'Description',
    [downloadCrsDataButtonLabel]: 'Download CRS data',
    [previousConfigurationLabel]: 'Previous Configuration',
    [newConfigurationLabel]: 'New Configuration',
};
